import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/fonts/fonts.css';
import './index.css';

// Physical entry point in HTML that "mounts" the app
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
